import { useRef, useEffect } from 'react'
import { Chart, ChartConfiguration, registerables } from 'chart.js'

Chart.register(...registerables)

export const useChart = (config: () => ChartConfiguration) => {
  const ref = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    if (!ref.current) return
    const chart = new Chart(ref.current.getContext('2d')!, config())

    // Fix zero-width canvas when container layout isn't settled yet
    const raf = requestAnimationFrame(() => {
      try { chart.resize() } catch { /* chart já destruído */ }
    })

    let ro: ResizeObserver | undefined
    if (typeof ResizeObserver !== 'undefined' && ref.current.parentElement) {
      ro = new ResizeObserver(() => { try { chart.resize() } catch { /* chart já destruído */ } })
      ro.observe(ref.current.parentElement)
    }

    return () => {
      cancelAnimationFrame(raf)
      ro?.disconnect()
      chart.destroy()
    }
  })

  return ref
}
